// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const yungoos: PokeData = {
  "id": 734,
  "name": "yungoos",
  "height": 4,
  "weight": 60,
  "base_experience": 51,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "thrash",
    "leer",
    "bite",
    "bide",
    "rest",
    "hyper-fang",
    "super-fang",
    "scary-face",
    "mud-slap",
    "pursuit",
    "crunch",
    "yawn",
    "odor-sleuth",
    "payback",
    "work-up"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "scary-face",
    "mud-slap",
    "pursuit",
    "crunch",
    "body-slam",
    "purification",
    "headbutt",
    "refresh",
    "splash",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 378,
    "item": null,
    "species": [
      {
        "name": "yungoos",
        "order": 734,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gumshoos",
        "order": 735,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 734,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 39,
    "speed": 45,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
